import React, { useMemo } from 'react'
import { func, string } from 'prop-types'

import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import { styles } from './styles'

const { Menu, Button } = Dropdown

const roles = [
  {
    key: 'agent',
    title: 'Agent',
  },
  {
    key: 'admin',
    title: 'Admin',
  },
]

// Get role name
export const getRole = key => {
  const roleObj = roles.find(item => item.key === key)
  if (roleObj) {
    return roleObj.title
  }
  return ''
}

export const menu = data => (
  <Menu>
    {data.map(({ title, key }) => (
      <Menu.Item key={key} itemKey={key}>
        {title}
      </Menu.Item>
    ))}
  </Menu>
)

const RoleSelection = ({ className, onSelect, role }) => {
  const memoizedMenu = useMemo(() => menu(roles), [])
  return (
    <Dropdown
      overlay={memoizedMenu}
      onSelect={onSelect}
      css={styles.dropdownMenu}
      className={className}
    >
      <Button css={styles.dropdownBtn}>{getRole(role)}</Button>
    </Dropdown>
  )
}

RoleSelection.propTypes = {
  className: string,
  onSelect: func,
  role: string,
}

RoleSelection.defaultProps = {
  className: undefined,
  onSelect() {},
  role: undefined,
}

export default RoleSelection
